import MODULE_ID from './moduleId';

import MediaHeader from './views/MediaHeader.vue';
import Media from './views/Media.vue';
class MediaRouteHandler {
  getRoutes = ({ moduleType }) => {
    return [
      {
        path: `/media/:instance/:folderId?/:fileId?`,
        name: 'Media',
        meta: {
          moduleType,
          initiateSyncBeforeNav: true,
          MODULE_ID,
          baseRoute: true,
        },
        components: { default: Media, header: MediaHeader },
      },
    ];
  };
}
export default new MediaRouteHandler();
